module.exports = __webpack_public_path__ + "img/family_body.9e1a84ec.png";